<template>
  <v-main style="position: absolute;">
    <v-dialog v-model="success" persistent>
      <v-card class="pa-7">
        <v-row>
          <v-col class="text-center"
            ><img
                    v-if="profile.pictureUrl"
                    style="
                      border-color: white;
                      height: 70px;
                    "
                    alt="Avatar"
                    :src="require('@/assets/coin.png')"
                  />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center pb-0"
            ><span class="headline1 font28 weight1000"
              >{{ $t("message.addPoint") }}</span
            ></v-col
          >
        </v-row>
        <v-row v-if="point">
          <v-col class="text-center pa-0"
            ><span class="headline1 font55 weight1000">{{ point }}</span></v-col
          >
        </v-row>
        <v-row>
          <v-col class="text-center pt-0"
            ><span class="headline1 font28 weight1000">{{ $t("message.point") }}</span></v-col
          >
        </v-row>
        <v-row>
          <v-col class="text-center">
            <v-btn rounded class="btn_icon1" dark @click="$router.push('home')">
              {{ $t("message.seePoint") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <div>
          <v-card >
            <v-img
              min-height="250"
              :src="require('@/assets/review-01.jpg')"
              style="background-color:FFB8A1"
            >
            <v-chip
              class="ma-2"
              color="rgb(235 246 130)"
              label
              text-color="black"
            >
              เลขที่ใบเสร็จ {{ this.$route.query.billingNumber }}
            </v-chip>
            </v-img>
          </v-card>
      </div>
      <div style="position: relative;top: -40px;" class="mb-5">
        <v-chip
          class="ma-2"
          color="rgb(235 246 130)"
          label
          text-color="black"
        >
          แบบประเมินความพึงพอใจ
        </v-chip>
        <!-- <div elevation="1" style="background-color:white;;border-top-left-radius: 44px;border-top-right-radius: 44px;" class="pa-6">
          <div style="text-align: end;">
          </div>
        </div> -->
        <div style="height: 100vh;background-color: white;" class="mb-5">
          <v-card class="text-center">
              <div v-if="this.data.length > 0">
                <v-col v-for="(item, i) in JSON.parse(question.answerChoice)" :key="i">
                  <div>
                    <p style="font-weight: bold;margin-bottom: 6px;text-align: start;"> <v-icon class="mr-1">mdi-chat-question</v-icon>{{ $t("message.noQuestions") }} {{i + 1}}</p>
                    <p style="padding: 5px;background-color: rgba(0, 0, 0, 0.08);font-size: 15px;border-radius: 10px;text-align: start;"> - {{ $i18n.locale === 'th' ? item[0].split('/')[0] : item[0].split('/')[1] === '' ? item[0].split('/')[0] : item[0].split('/')[1]}} ?</p>
                  </div>
                  <div  v-if="question.answerType === 'คำตอบแบบ 1 ตัวเลือก'" style="padding: 10px;background-color: rgb(0 0 0 / 8%);border-radius: 10px;">
                    <div style="text-align: start;padding-left: 5px;font-weight: bold;margin-bottom: 5px;">* {{ $t("message.oneAnswer") }}</div>
                    <div v-for="(item2, index) in item.filter((value, index) => { return index > 0})" :key="index">
                      <v-card :class="(answer1Choice !== null && answer1Choice[i][1] === item2) ? 'activeAnswer': 'answer'" @click="select1Choice(item2,i)">
                        <div>{{$i18n.locale === 'th' ? item2.split('/')[0] : item2.split('/')[1] === '' ? item2.split('/')[0] : item2.split('/')[1]}}</div>
                        <v-icon color="white" v-if="answer1Choice !== null && answer1Choice[i][1] === item2">mdi-check-circle</v-icon>
                        <v-icon color="grey" v-else>mdi-checkbox-blank-circle-outline</v-icon>
                      </v-card>
                    </div>
                  </div>
                  <div  v-if="question.answerType === 'คำตอบแบบมากกว่า 1 ตัวเลือก'" style="padding: 10px;background-color: rgb(0 0 0 / 8%);border-radius: 10px;">
                    <div style="text-align: start;padding-left: 5px;font-weight: bold;margin-bottom: 5px;">* {{ $t("message.moreChoice") }}</div>
                    <div v-for="(item2, index) in item.filter((value, index) => { return index > 0})" :key="index">
                      <v-card :class="answer1Choice !== null && answer1Choice[i].filter((value2, index2) =>  index2 > 0).some(item10 =>  item10  === item2) ? 'activeAnswer': 'answer'" @click="select1Choice(item2,i)">
                        <div>{{$i18n.locale === 'th' ? item2.split('/')[0] : item2.split('/')[1] === '' ? item2.split('/')[0] : item2.split('/')[1]}}</div>
                        <v-icon color="white" v-if="answer1Choice !== null && answer1Choice[i].filter((value2, index2) =>  index2 > 0).some(item10 =>  item10  === item2)">mdi-check-circle</v-icon>
                        <v-icon color="grey" v-else>mdi-checkbox-blank-circle-outline</v-icon>
                      </v-card>
                    </div>
                  </div>
                </v-col>
              </div>
              <v-card>
              <v-card-text>
                <v-form ref="form_add" v-model="valid" lazy-validation v-if="formUpdate2.title">
                <v-container class="pl-4 pr-4 pt-5">
                  <v-row justify="center">
                    <v-col class="text-center">
                      <b class="font24">{{ $t("message.EnterData") }}</b>
                    </v-col>
                  </v-row>
                  <v-row v-if="formUpdate2.field1Title">
                    <v-col cols="12">
                      <div>
                        <p style="text-align: start;font-weight: bold;margin-bottom: 6px;"> <v-icon class="mr-1">mdi-chat-question</v-icon>{{ $t("message.noQuestions") }} 1</p>
                        <p style="text-align: start;padding: 5px;background-color: rgba(0, 0, 0, 0.08);font-size: 15px;border-radius: 10px;">{{ $i18n.locale === 'th' ? formUpdate2.field1Title[0] : formUpdate2.field1Title[1] }}</p>
                      </div>
                      <v-textarea
                        v-if="formUpdate2.field1Type !== 'dateTime'"
                        outlined
                        dense
                        :rules="
                          formUpdate2.field1Type === 'citizenNumber'
                            ? [formUpdate2.key1.email]
                            : formUpdate2.field1Type === 'email'
                            ? [formUpdate2.key1.email]
                            : [formUpdate2.key1.required]
                        "
                        required
                        v-model="formUpdateItem.field1Value"
                      ></v-textarea>
                      <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formUpdateItem.field1Value"
                            :label="formUpdate2.field1Title[0]"
                            readonly
                            v-if="formUpdate2.field1Type == 'dateTime'"
                            dense
                            :rules="[formUpdate2.key1.required]"
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          ref="picker1"
                          v-model="formUpdateItem.field1Value"
                          :max="new Date().toISOString().substr(0, 10)"
                          min="1950-01-01"
                          @change="save1"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row v-if="formUpdate2.field2Title">
                    <v-col cols="12">
                      <div>
                        <p style="text-align: start;font-weight: bold;margin-bottom: 6px;"> <v-icon class="mr-1">mdi-chat-question</v-icon>{{ $t("message.noQuestions") }} 2</p>
                        <p style="text-align: start;padding: 5px;background-color: rgba(0, 0, 0, 0.08);font-size: 15px;border-radius: 10px;">{{ $i18n.locale === 'th' ? formUpdate2.field2Title[0] : formUpdate2.field2Title[1] }}</p>
                      </div>
                      <v-textarea
                        v-if="formUpdate2.field2Type !== 'dateTime'"
                        outlined
                        dense
                        :rules="
                          formUpdate2.field2Type === 'citizenNumber'
                            ? [formUpdate2.key1.email]
                            : formUpdate2.field2Type === 'email'
                            ? [formUpdate2.key1.email]
                            : [formUpdate2.key1.required]
                        "
                        required
                        v-model="formUpdateItem.field2Value"
                      ></v-textarea>
                      <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formUpdateItem.field2Value"
                            :label="formUpdate2.field2Title[0]"
                            readonly
                            :rules="[v => !!v || 'This field is required']"
                            v-if="formUpdate2.field2Type == 'dateTime'"
                            dense
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          ref="picker1"
                          v-model="formUpdateItem.field2Value"
                          :max="new Date().toISOString().substr(0, 10)"
                          min="1950-01-01"
                          @change="save1"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row v-if="formUpdate2.field3Title">
                    <v-col cols="12">
                      <div>
                        <p style="text-align: start;font-weight: bold;margin-bottom: 6px;"> <v-icon class="mr-1">mdi-chat-question</v-icon>{{ $t("message.noQuestions") }} 3</p>
                        <p style="text-align: start;;padding: 5px;background-color: rgba(0, 0, 0, 0.08);font-size: 15px;border-radius: 10px;">{{ $i18n.locale === 'th' ? formUpdate2.field3Title[0] : formUpdate2.field3Title[1] }}</p>
                      </div>
                      <v-text-field
                        v-if="formUpdate2.field3Type !== 'dateTime'"
                        outlined
                        dense
                        :rules="
                          formUpdate2.field3Type === 'citizenNumber'
                            ? [formUpdate2.key1.email]
                            : formUpdate2.field3Type === 'email'
                            ? [formUpdate2.key1.email]
                            : [formUpdate2.key1.required]
                        "
                        required
                        v-model="formUpdateItem.field3Value"
                      ></v-text-field>
                      <v-menu
                        ref="menu3"
                        v-model="menu3"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formUpdateItem.field3Value"
                            :label="formUpdate2.field3Title[0]"
                            readonly
                            :rules="[formUpdate2.key3.required]"
                            v-if="formUpdate2.field3Type == 'dateTime'"
                            dense
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          ref="picker3"
                          v-model="formUpdateItem.field3Value"
                          :max="new Date().toISOString().substr(0, 10)"
                          min="1950-01-01"
                          @change="save3"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row v-if="formUpdate.field4Title">
                    <v-col cols="12">
                      <div>
                        <p style="text-align: start;font-weight: bold;margin-bottom: 6px;"> <v-icon class="mr-1">mdi-chat-question</v-icon>{{ $t("message.noQuestions") }} 4</p>
                        <p style="text-align: start;;padding: 5px;background-color: rgba(0, 0, 0, 0.08);font-size: 15px;border-radius: 10px;">{{ $i18n.locale === 'th' ? formUpdate2.field4Title[0] : formUpdate2.field4Title[1] }}</p>
                      </div>
                      <v-text-field
                        v-if="formUpdate2.field4Type !== 'dateTime'"
                        outlined
                        dense
                        :rules="
                          formUpdate2.field4Type === 'citizenNumber'
                            ? [formUpdate2.key1.email]
                            : formUpdate2.field4Type === 'email'
                            ? [formUpdate2.key1.email]
                            : [formUpdate2.key1.required]
                        "
                        required
                        v-model="formUpdateItem.field4Value"
                      ></v-text-field>
                      <v-menu
                        ref="menu4"
                        v-model="menu4"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formUpdateItem.field4Value"
                            :label="formUpdate2.field4Title[0]"
                            prepend-icon="event"
                            readonly
                            v-if="formUpdate2.field4Type == 'dateTime'"
                            dense
                            :rules="[formUpdate2.key4.required]"
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          ref="picker4"
                          v-model="formUpdateItem.field4Value"
                          :max="new Date().toISOString().substr(0, 10)"
                          min="1950-01-01"
                          @change="save4"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-container>
                </v-form>
              </v-card-text>
              <v-divider style="margin: 0;"></v-divider>
              <v-card-actions class="text-center" style="justify-content: space-evenly;padding-bottom:20px">
                    <v-btn
                      class="white--text"
                      color="#69dd61"
                      width="auto"
                      block
                      style="border-radius: 15px;font-size: 16px;"
                      :disabled="!valid || statusCheckAnswer"
                      :loading="loading"
                      @click="senddata"
                    >
                    🎁 {{ $t("message.get") }}{{ $t("message.point") }}
                    </v-btn>
              </v-card-actions>
              </v-card>
          </v-card>
        </div>
      </div>
  </v-main>
</template>
<style scoped>
/* .card1 {
height: 100%;
overflow: hidden;
background-color: --color_headline1 !important;
border-radius: 0px 0px 0px 0px;
} */
.card {
height: 100%;
overflow: hidden;
}
.cardbg {
background-repeat: no-repeat !important;
background-size: 90% 110% !important;
background-attachment: fixed;
background-position: center;
}
</style>
<script>
import HeaderProfile from '../../HeaderProfile'
import MenuItem from '../../MenuItem'
import AllActivity from '../../AllActivity'
import axios from 'axios'
import ActivityBackup from '../../ActivityBackup'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ActivityMain',
  metaInfo: {
  // title: 'My Activity',
    meta: [
      { property: `og:title`, content: 'กิจกรรม' },
      { property: 'og:image', content: 'https://storage.googleapis.com/betask-linked/static/upload/Shop/SH261_20221229231505684117.jpeg' }
    ]
  },
  components: {
    'header-profile': HeaderProfile,
    'menu-item': MenuItem,
    'all-activity': AllActivity,
    'activity-backup': ActivityBackup
  },
  data () {
    return {
      success: false,
      menu1: false,
      menu2: false,
      menu3: false,
      loading: false,
      menu4: false,
      dialog: true,
      activity: null,
      point: null,
      liffId: null,
      member: null,
      allCoin: 0,
      answer1Choice: null,
      allPoint: null,
      profile: [],
      link: null,
      data: null,
      data2: null,
      question: null,
      statusCheckAnswer: true,
      valid: true,
      formUpdate: {
        activityId: '',
        field1Title: '',
        field1Type: '',
        key1: {},
        chkKey: '',
        field2Title: '',
        field2Type: '',
        key2: {},
        field3Title: '',
        field3Type: '',
        key3: {},
        field4Title: '',
        field4Type: '',
        key4: {},
        primary: '',
        coin: '',
        pictureUrl: '',
        title: ''
      },
      formUpdate2: {
        activityId: '',
        field1Title: '',
        field1Type: '',
        key1: {},
        chkKey: '',
        field2Title: '',
        field2Type: '',
        key2: {},
        field3Title: '',
        field3Type: '',
        key3: {},
        field4Title: '',
        field4Type: '',
        key4: {},
        primary: '',
        coin: '',
        pictureUrl: '',
        title: ''
      },
      formUpdateItem: {
        field1Value: '',
        field2Value: '',
        field3Value: '',
        field4Value: ''
      }
    }
  },
  async mounted () {
    try {
      if (this.$route.query.billingNumber) {
        this.member = this.GET_MEMBERINFO()
        this.profile = this.getLiffProfile()
        await this.getActivity()
        window.scrollTo(0, 0)
        const result2 = await axios.get(this.DNS_IP + `/qrcode/get?bvpBillingNumber=${this.$route.query.billingNumber}`)
        const result = await axios.get(this.DNS_IP + `/activityLog/checkBillingBvp?billingNumber=${this.$route.query.billingNumber}`)
        if (Array.isArray(result2.data)) {
          if (Array.isArray(result.data)) {
            alert('เลขบิลนี้ทำแบบสอบถามเเล้ว')
            if (this.$liff.isInClient()) {
              this.$liff.closeWindow()
            }
          } else {
            const result = await axios.get(this.DNS_IP + `/activity/get/bvp`)
            this.data = result.data.filter(item => item.answerType !== 'คำตอบแบบข้อความ')
            this.data2 = result.data.filter(item => item.answerType === 'คำตอบแบบข้อความ')
            await this.convertActivityChoice(this.data[0])
            await this.convertActivityText(this.data2[0])
          }
        } else {
          alert('เลขบิลนี้ได้ถูกทำการยกเลิก')
          if (this.$liff.isInClient()) {
            this.$liff.closeWindow()
          }
        }
      } else {
        alert('ไม่มีเลขบิล')
      }
    } catch (error) {
      console.error('errorerrorerrorerror')
    }
  },
  methods: {
    ...mapActions('memberStore', ['getMemberProfile']),
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    async senddata () {
      this.loading = true
      if (this.data.length > 0) {
        const params = {
          field1Value: this.formUpdateItem.field1Value,
          field2Value: this.formUpdateItem.field2Value,
          field3Value: this.formUpdateItem.field3Value,
          field4Value: this.formUpdateItem.field4Value,
          bvpBillingNumber: this.$route.query.billingNumber,
          answerForChoice: this.answer1Choice !== null ? JSON.stringify(this.answer1Choice) : null
        }
        const result = await this.callBeTaskAPIActivity(
          'post',
          `/activityLog/bvp/add`,
          params,
          this.data[0].activityId
        )
        if (result.status) {
          this.point = parseInt(result.coin)
          if (this.data2.length > 0) {
            this.success = false
          } else {
            this.success = true
          }
          await this.getMemberProfile()
          this.member = this.GET_MEMBERINFO()
        }
      }
      if (this.data2.length > 0) {
        const params = {
          field1Value: this.formUpdateItem.field1Value,
          field2Value: this.formUpdateItem.field2Value,
          field3Value: this.formUpdateItem.field3Value,
          field4Value: this.formUpdateItem.field4Value,
          bvpBillingNumber: this.$route.query.billingNumber
        }
        const result = await this.callBeTaskAPIActivity(
          'post',
          `/activityLog/bvp/add`,
          params,
          this.data2[0].activityId
        )
        if (result.status) {
          if (this.data.length > 0) {
            this.point += parseInt(result.coin)
          } else {
            this.point = result.coin
          }
          // # dataNotifyInsert.update({"name": 'รายการรับคะแนน'})
          // # dataNotifyInsert.update({"details": 'คุณได้รับ ' + str(math.floor(int(coin))) + ' คะแนน'})
          // # dataNotifyInsert.update({"lineUserId": lineUserId})
          // # dataNotifyInsert.update({"notifyStatus": 'show'})
          // # dataNotifyInsert.update({"shopId": shopId})
          // # dataNotifyInsert.update({"source": 'collect'})
          // # dataNotifyInsert.update({"memberId": memberId})
          // # dataNotifyInsert.update({"CREATE_USER": memberId})
          // # dataNotifyInsert.update({"LAST_USER": memberId})
        }
      }
      let data = {
        'name': 'รายการรับคะแนนแบบสอบถาม',
        'details': 'คุณได้รับ ' + this.point.toString() + ' คะแนน',
        'lineUserId': this.profile.userId,
        'notifyStatus': 'show',
        'refId': this.$route.query.billingNumber,
        'shopId': this.shopNameData.bpv,
        'source': 'collect',
        'memberId': this.profile.memberId,
        'CREATE_USER': this.profile.memberId,
        'LAST_USER': this.profile.memberId
      }
      await axios.post(this.DNS_IP + '/notify/add', data)
      this.success = true
      await this.getMemberProfile()
      this.member = this.GET_MEMBERINFO()
      this.loading = false
    },
    async callBeTaskAPIActivity (method, url, params, activityId) {
      let result = null
      await axios({
        method: method,
        headers: {
          shopId: this.shopId,
          lineUserId: this.profile.userId,
          memberId: this.profile.memberId,
          activityId: activityId
        },
        url: this.DNS_IP + url,
        data: params
      })
        .then((response) => {
          result = response.data
        })
        .catch((error) => {
          console.error(error)
          result = null
        })
      return result
    },
    async getActivity () {
      const result = await this.callBeTaskAPI('get', `/activity/line/get`)
      if (Array.isArray(result)) {
        this.activity = result.filter(item => item.type !== 'FreeCoin').filter(item => item.bvpStatusQuestionnaire === 'True')
      }
    },
    async convertActivityChoice (item) {
      try {
        if (item.type === 'กรอกข้อมูล' && item.answerType === 'คำตอบแบบ 1 ตัวเลือก') {
          this.formUpdate.activityId = item.activityId
          this.formUpdate.pictureUrl = item.pictureUrl
          this.formUpdate.title = item.title
          this.formUpdate.coin = item.coin
          this.coinChk = item.coin
          this.answer1Choice = []
          this.question = item
          let arrayForquestion = JSON.parse(item.answerChoice)
          arrayForquestion.forEach(element => this.answer1Choice.push([element[0]]))
        } else if (item.type === 'กรอกข้อมูล' && item.answerType === 'คำตอบแบบมากกว่า 1 ตัวเลือก') {
          this.formUpdate.activityId = item.activityId
          this.formUpdate.title = item.title
          this.formUpdate.coin = item.coin
          this.coinChk = item.coin
          this.answer1Choice = []
          this.question = item
          let arrayForquestion = JSON.parse(item.answerChoice)
          arrayForquestion.forEach(element => this.answer1Choice.push([element[0]]))
        }
      } catch (error) {
        console.error(error)
      }
    },
    select1Choice (item2, i) {
      if (this.question.answerType === 'คำตอบแบบ 1 ตัวเลือก') {
        if (this.answer1Choice[i].some(a => a === item2)) {
          const index = this.answer1Choice[i].indexOf(item2)
          this.answer1Choice[i].splice(index, 1)
        } else {
          if (this.answer1Choice[i].length === 1) {
            this.answer1Choice[i].push(item2)
          } else if (this.answer1Choice[i].length > 1) {
            this.answer1Choice[i].splice(1, 1)
            this.answer1Choice[i].push(item2)
          }
        }
      } else if (this.question.answerType === 'คำตอบแบบมากกว่า 1 ตัวเลือก') {
        if (this.answer1Choice[i].some(a => a === item2)) {
          const index = this.answer1Choice[i].indexOf(item2)
          this.answer1Choice[i].splice(index, 1)
        } else {
          this.answer1Choice[i].push(item2)
        }
      }
      this.checkAnswer()
    },
    async convertActivityText (item) {
      this.formUpdate2.activityId = item.activityId
      this.formUpdate2.field1Title = item.field1Title ? JSON.parse(item.field1Title) : item.field1Title
      this.formUpdate2.field1Type = item.field1Type
      this.formUpdate2.field2Title = item.field2Title ? JSON.parse(item.field2Title) : item.field2Title
      this.formUpdate2.field2Type = item.field2Type
      this.formUpdate2.field3Title = item.field3Title ? JSON.parse(item.field3Title) : item.field3Title
      this.formUpdate2.field3Type = item.field3Type
      this.formUpdate2.field4Title = item.field4Title ? JSON.parse(item.field4Title) : item.field4Title
      this.formUpdate2.field4Type = item.field4Type
      this.formUpdate2.primary = item.Primary_field
      this.formUpdate2.pictureUrl = item.pictureUrl
      this.formUpdate2.title = item.title
      this.formUpdate2.coin = item.coin
      // this.formUpdateItem.field1Value = ''
      // this.formUpdateItem.field2Value = ''
      // this.formUpdateItem.field3Value = ''
      // this.formUpdateItem.field4Value = ''
      switch (item.Primary_field) {
        case '1':
          this.formUpdate.key1 = {
            numberRules: (value) =>
              (!isNaN(parseFloat(value)) &&
            value >= 0 &&
            value <= 9999999999) ||
          `${this.$t('message.fillNum')}`,
            counterTel: (value) => value.length <= 10 || 'Max 10 characters',
            IDcardRules: (value) =>
              (!isNaN(parseFloat(value)) &&
            value >= 0 &&
            value <= 9999999999999) ||
          `${this.$t('message.fillNum')}`,
            required: (value) => !!value || 'กรุณากรอก.',
            resizeImag: (value) =>
              !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
            counterIDcard: (value) =>
              value.length <= 13 || 'Max 13 characters',
            email: (value) => {
              const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              return pattern.test(value) || 'Invalid e-mail.'
            }
          }
          this.formUpdate.key2 = {
            required: (value) => value.length <= 5000
          }
          this.formUpdate.key3 = {
            required: (value) => value.length <= 5000
          }
          this.formUpdate.key4 = {
            required: (value) => value.length <= 5000
          }
          // this.formUpdate.chkKey = '/activityData/get?field1Value=' + this.formUpdateItem.field1Value + '&activityId=' + this.formUpdate.activityId
          break
        case '2':
          this.formUpdate.key2 = {
            numberRules: (value) =>
              (!isNaN(parseFloat(value)) &&
            value >= 0 &&
            value <= 9999999999) ||
          `${this.$t('message.fillNum')}`,
            counterTel: (value) => value.length <= 10 || 'Max 10 characters',
            IDcardRules: (value) =>
              (!isNaN(parseFloat(value)) &&
            value >= 0 &&
            value <= 9999999999999) ||
          `${this.$t('message.fillNum')}`,
            required: (value) => !!value || 'กรุณากรอก.',
            resizeImag: (value) =>
              !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
            counterIDcard: (value) =>
              value.length <= 13 || 'Max 13 characters',
            email: (value) => {
              const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              return pattern.test(value) || 'Invalid e-mail.'
            }
          }
          this.formUpdate.key1 = {
            required: (value) => value.length <= 5000
          }
          this.formUpdate.key3 = {
            required: (value) => value.length <= 5000
          }
          this.formUpdate.key4 = {
            required: (value) => value.length <= 5000
          }
          // this.formUpdate.chkKey = '/activityData/get?field2Value=' + this.formUpdateItem.field2Value + '&activityId=' + this.formUpdate.activityId
          break
        case '3':
          this.formUpdate.key3 = {
            numberRules: (value) =>
              (!isNaN(parseFloat(value)) &&
            value >= 0 &&
            value <= 9999999999) ||
          `${this.$t('message.fillNum')}`,
            counterTel: (value) => value.length <= 10 || 'Max 10 characters',
            IDcardRules: (value) =>
              (!isNaN(parseFloat(value)) &&
            value >= 0 &&
            value <= 9999999999999) ||
          `${this.$t('message.fillNum')}`,
            required: (value) => !!value || 'กรุณากรอก.',
            resizeImag: (value) =>
              !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
            counterIDcard: (value) =>
              value.length <= 13 || 'Max 13 characters',
            email: (value) => {
              const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              return pattern.test(value) || 'Invalid e-mail.'
            }
          }
          this.formUpdate.key1 = {
            required: (value) => value.length <= 5000
          }
          this.formUpdate.key2 = {
            required: (value) => value.length <= 5000
          }
          this.formUpdate.key4 = {
            required: (value) => value.length <= 5000
          }
          // this.formUpdate.chkKey = '/activityData/get?field3Value=' + this.formUpdateItem.field3Value + '&activityId=' + this.formUpdate.activityId
          break
        case '4':
          this.formUpdate.key4 = {
            numberRules: (value) =>
              (!isNaN(parseFloat(value)) &&
            value >= 0 &&
            value <= 9999999999) ||
          `${this.$t('message.fillNum')}`,
            counterTel: (value) => value.length <= 10 || 'Max 10 characters',
            IDcardRules: (value) =>
              (!isNaN(parseFloat(value)) &&
            value >= 0 &&
            value <= 9999999999999) ||
          `${this.$t('message.fillNum')}`,
            required: (value) => !!value || 'กรุณากรอก.',
            resizeImag: (value) =>
              !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
            counterIDcard: (value) =>
              value.length <= 13 || 'Max 13 characters',
            email: (value) => {
              const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              return pattern.test(value) || 'Invalid e-mail.'
            }
          }
          this.formUpdate.key1 = {
            required: (value) => value.length <= 5000
          }
          this.formUpdate.key2 = {
            required: (value) => value.length <= 5000
          }
          this.formUpdate.key3 = {
            required: (value) => value.length <= 5000
          }
          // this.formUpdate.chkKey = '/activityData/get?field4Value=' + this.formUpdateItem.field4Value + '&activityId=' + this.formUpdate.activityId
          break
        case '':
          this.formUpdate2.key1 = {
            numberRules: (value) =>
              (!isNaN(parseFloat(value)) &&
            value >= 0 &&
            value <= 9999999999) ||
            `${this.$t('message.fillNum')}`,
            counterTel: (value) => value.length <= 10 || 'Max 10 characters',
            IDcardRules: (value) =>
              (!isNaN(parseFloat(value)) &&
            value >= 0 &&
            value <= 9999999999999) ||
          `${this.$t('message.fillNum')}`,
            required: (value) => !!value || `${this.$t('message.fill')}`,
            resizeImag: (value) =>
              !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
            counterIDcard: (value) =>
              value.length <= 13 || 'Max 13 characters',
            email: (value) => {
              const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              return pattern.test(value) || 'Invalid e-mail.'
            }
          }
          this.formUpdate2.key2 = {
            required: (value) => value.length <= 5000
          }
          this.formUpdate2.key3 = {
            required: (value) => value.length <= 5000
          }
          this.formUpdate2.key4 = {
            required: (value) => value.length <= 5000
          }
          // this.formUpdate.chkKey = '/activityData/get?field1Value=' + this.formUpdateItem.field1Value + '&activityId=' + this.formUpdate.activityId
          break
        default:
          break
      }
      this.validate()
    },
    checkAnswer () {
      this.statusCheckAnswer = this.answer1Choice.some(a => a.length === 1)
    },
    save1 (date) {
      this.$refs.menu1.save(date)
    },
    save2 (date) {
      this.$refs.menu2.save(date)
    },
    save3 (date) {
      this.$refs.menu3.save(date)
    },
    save4 (date) {
      this.$refs.menu4.save(date)
    },
    validate () {
      this.$nextTick(() => {
        let self = this
        self.$refs.form_add.validate()
      })
    }
  }
}
</script>
<style>
div.sticky {
position: -webkit-sticky;
position: sticky;
top: 0;
}
.custom-dialog.v-dialog{
  margin: 10px;
}

.custom-dialog.v-dialog:not(.v-dialog--fullscreen) {
max-height: 50%;
}
.answer {
  margin-bottom: 2px;
  padding: 6px;
  text-align: center;
  transition: all ease 0.4s;
  display: flex !important;
  justify-content: space-between;
  padding: 20px 24px;
  font-size: 15px;
  border-radius: 10px !important;
}
.activeAnswer {
  margin-bottom: 2px;
  padding: 6px;
  text-align: center;
  background-color: rgb(92 118 232) !important;
  transform: translateY(0px);
  color: white !important;
  transition: all ease 0.4s;
  display: flex !important;
  justify-content: space-between;
  padding: 20px 24px;
  border-radius: 10px !important;
  font-size: 15px;
}
.activity-card{
  border-radius: 25px !important;
  padding: 10px 0 0 0;
  /* background-color: #6683D3; */
  top: 0;
  transition: all .2s;
  position: relative;
}
.activity-card:active {
  top: 3px;
  box-shadow: 0 10px 0px #3f51b5;
  transition: all .2s;
}
.footer {
  margin-top: 20px;
  position: fixed; /* เปลี่ยนจาก fixed เป็น relative */
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: red;
  color: white;
  text-align: center;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Activity/BvpQuestions.vue